import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import events from './modules/events'
import locationFactory from './modules/location'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    auth,
    events,
    account: locationFactory('account'),
    office: locationFactory('office'),
    district: locationFactory('district'),
    region: locationFactory('region'),
    division: locationFactory('division'),
    territory: locationFactory('territory')
  },
  strict: debug,
  state: {},
  mutations: {},
  actions: {}
})
